import config from '../../config';
import { makeAPICall, APIError, getCurrentOrgIdByContext } from '../generalCreators';
import { getShapeSet } from './basicCreators';

export function updateCurrentShapeSet(shapeSetId, context = 'global') {
  return function(dispatch, getState) {
    if (shapeSetId) {
      // Get the shapeSet details
      return dispatch(getShapeSet(shapeSetId, context)).then(
        shapeSet => dispatch({ type: 'UPDATE_CURRENT_SHAPESET', shapeSet })
      );
    } else {
      return dispatch(clearCurrentShapeSet());
    }
  }
}

export function getShapeSetSettings(context) {
  return function(dispatch, getState) {
    const organisationId = getCurrentOrgIdByContext(context, getState);
    const endpoint = '/shapeset/settings';
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId }
    };

    if (organisationId) {
      options.params.organisationId = organisationId;
    }

    return makeAPICall(endpoint, options).then(
      response => dispatch({ type: 'UPDATE_CURRENT_SHAPESET_SETTINGS', settings: response.data }),
      error => dispatch(APIError(error, 'Error getting shapeSet settings'))
    );
  };
}

export function clearCurrentShapeSet() {
  return { type: 'CLEAR_CURRENT_SHAPESET' }
}

export function getDownloadUrl(shapeSetId, context) {
  return function(dispatch, getState) {
     const endpoint = `/shapeset/downloadurl/${shapeSetId}`;
     const options = {
       method: "GET",
       headers: { token: getState().authentication.token },
       params: { productId: config.productId }
     };

     if (context === 'customer') {
      const organisationId = getState().currentOrganisation.id;
      options.params.organisationId = organisationId;
     }

     return makeAPICall(endpoint, options).then(
       response => dispatch({ type: 'UPDATE_CURRENT_SHAPESET_DOWNLOAD_URL', url: response.data }),
       error => {
          dispatch({ type: 'UPDATE_CURRENT_SHAPESET_DOWNLOAD_URL', url: undefined });
          return dispatch(APIError(error, 'Error getting shapeSet download URL'))
        }
     );
  }
}



// WEBPACK FOOTER //
// ./src/actions/shapeSets/currentShapeSetCreators.js